module.exports = __webpack_public_path__ + "ecca390cee1d49094566c6993747d6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/angel.jpg
// module id = vUx2
// module chunks = 13